import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from '../../elements/Title';
import apiClient from "../../apiClient";

import Logo1 from '../../assets/logos/1.png';
import Logo2 from '../../assets/logos/2.png';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function DashboardIncomeRecent(props) {
  const classes = useStyles();
  const [data, setData] = useState(props.users);

  useEffect(() => {
    // console.log(props.users);
    setData(props.users)
  },[props]);

  return (
    <React.Fragment>
      <Title>Recent Staff</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><b>Name</b></TableCell>
            <TableCell><b>Surname</b></TableCell>
            <TableCell><b>Designation</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data ? 
            data.slice(0, 5).map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.surname}</TableCell>
                <TableCell>{row.designation}</TableCell>
              </TableRow>
            ))
            :
            null
          }
        </TableBody>
      </Table>
      <div className={classes.seeMore}>
        <Link color="primary" to="/staff">
          See more
        </Link>
      </div>
    </React.Fragment>
  );
}